import React from "react";
import "../assets/css/questionpages.css";

const ProgressDot = ({ currentPage, totalPages }) => {
  // Percentage of the line to fill
  const percent =
    totalPages > 1
      ? ((currentPage - 1) / (totalPages - 1)) * 100
      : 0;


      
  const lineStyle = {
    background: `linear-gradient(to right, #725581 ${percent}%, #ddd ${percent}%)`,
  };

  return (
     <div className="progress-container">
    <div className="progress-wrapper">
      <div
        className="progress-line"
        style={lineStyle}
      />
      {Array.from({ length: totalPages }, (_, i) => {
        const page = i + 1;
        let className = "progress-dot inactive";
        if (page < currentPage) className = "progress-dot completed"; 
        if (page === currentPage) className = "progress-dot active";

        return (
          <div
            key={page}
            className={className}
            /* style={{
              left:
                totalPages > 1
                  ? `${(i / (totalPages - 1)) * 100}%`
                  : "0",
            }} */
          >
            {page}
          </div>
        );
      })}
    </div>
    </div>
  );
};

export default ProgressDot;
